import { PopOverContent } from './Content/PopOverContent';
import { PopOver as PopOverRoot } from './PopOver';
import { PopOverTrigger } from './Trigger/PopOverTrigger';

export const PopOver = Object.assign(PopOverRoot, {
  Trigger: PopOverTrigger,
  Content: PopOverContent,
});
